import { useEffect } from 'react';
import './App.css'
import CommonRouts from './routes/CommonRoutes'
import { onMessage } from 'firebase/messaging';
import { messaging } from './firebase';
import { useDispatch } from 'react-redux';
import { fetchNotificationCount } from './store/feature/UserSlice';
import { NotificationToast } from './components/common/NotificationToast';
import { getMyToken } from './utility/helper';

function App() {
  const dispatch = useDispatch();

  // Fetch initial notification count on app mount if authenticated
  useEffect(() => {
    const token = getMyToken();
    if (token) {
      dispatch(fetchNotificationCount() as any);
    }
  }, [dispatch]);

  useEffect(() => {
    const unsubscribe = onMessage(messaging, (payload) => {
      const token = getMyToken();
      if (!token) return;

      // Small delay to ensure database state is updated before fetching the new count
      setTimeout(() => {
        dispatch(fetchNotificationCount() as any);
      }, 1000);


      const title = payload?.notification?.title || payload?.data?.title || 'New Notification';
      const body = payload?.notification?.body || payload?.data?.body || '';

      // playNotificationSound();
      NotificationToast(title, body);
    });

    return () => unsubscribe();
  }, [dispatch]);




  return (
    <>
      <CommonRouts />
    </>
  )
}

export default App
